import {Dispatch} from 'react'
import {SUJETO_EXCLUIDO_TYPES} from '../../constants/sujetoExcluido.types'

import * as validaciones from '../../utils/strings.utils'
import {State} from '../../reducers'
import * as validators from '../../utils/validaciones'
import {generalOpenModalError, generalOpenModalInfo} from '../general.actions'
import {aMonto, montosDeLinea, precioUnitarioNeto, redondear2, retencionRenta} from '../../utils/calculo-dte'
import {
  SECalculoArrayProductos,
  SEProductosF,
  SujetoExcluidoAction,
} from '../../interfaces/sujeto-excluido.interface'


// ******************************************************************************************
export const sujetoExcluidoFormProductoHandleChange = (formProducto: SEProductosF) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_HANDLE_CHANGE,
  payload: formProducto,
})

export const sujetoExcluidoFormProductoAddError = (formError: SEProductosF) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_SET_ERRORS,
  payload: formError,
})

export const sujetoExcluidoFormProductoClear = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_CLEAR,
  payload: null,
})

export const sujetoExcluidoArrayProductoAgregar = (producto: SEProductosF) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_ADD,
  payload: producto,
})

export const sujetoExcluidoArrayProductoDeleteOne = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_DELETE_ONE,
  payload: null,
})

export const sujetoExcluidoArrayProductoClearAll = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_CLEAR_ALL,
  payload: null,
})

export const sujetoExcluidoArrayProductoSetCalculos = (calculos: SECalculoArrayProductos) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_SET_CALCULOS,
  payload: calculos,
})

export const sujetoExcluidoArrayProductoSelectOne = (i: number) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_SELECT_ONE,
  payload: i,
})

export const sujetoExcluidoArrayProductoEditar = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_EDIT,
  payload: null,
})

export const sujetoExcluidoFormProductoHandleChangeEdit = (formProducto: SEProductosF) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_HANDLE_CHANGE_EDIT,
  payload: formProducto,
})

export const sujetoExcluidoFormProductoAddErrorEdit = (formError: SEProductosF) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_SET_ERRORS_EDIT,
  payload: formError,
})

export const sujetoExcluidoDeleteServicios = () => ({ type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_DELETE_SERVICIOS, payload: null})

// ******************************************************************************************
// * ACCIONES DE MODALES
export const sujetoExcluidoModalsOpenEliminar = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALELIMINAR_OPEN,
  payload: {activeEliminarUno: true},
})

export const sujetoExcluidoModalsOpenQuitarTodo = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALELIMINAR_OPEN,
  payload: {activeQuitarTodo: true},
})

export const sujetoExcluidoModalsClose = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALELIMINAR_CLOSE,
  payload: null,
})

export const sujetoExcluidoOpenModalEditar = (i: number, producto: SEProductosF) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALEDITAR_OPEN,
  payload: {productoSeleccionado: i, formProductosEdit: producto},
})

export const sujetoExcluidoCloseModalEditar = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALEDITAR_CLOSE,
  payload: null,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const sujetoExcluidoFormProductoHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    const edit = getState().sujetoExcluido.modals.activeEditar
    let {name, value} = e.target
    if (value) {
      switch (name) {
        case 'descripcion':
          if (!validaciones.validarRegexLetras(value)) return
          break
        case 'cantidad':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        case 'precio':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        case 'tipoDescuento':
          break
        case 'descuento':
          if (!validaciones.validaRegexNumericoFloatNDecimales(value)) return
          break
        default:
          break
      }
    }
    if (edit) dispatch(sujetoExcluidoFormProductoHandleChangeEdit({[name]: value}))
    else dispatch(sujetoExcluidoFormProductoHandleChange({[name]: value}))
  }

export const sujetoExcluidoFormProductoUpdateCalculo = () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    const edit = getState().sujetoExcluido.modals.activeEditar
    const {cantidad, precio, descuento, tipoDescuento} = edit ? getState().sujetoExcluido.formProductosEdit : getState().sujetoExcluido.formProductos

    const impuesto1 = 0, totalImpuesto1 = 0
    let subtotal_ = 0, descuento_ = 0, total_ = 0, totalConImpuesto1 = 0, totalConImpuesto1Desc = 0

    if (cantidad && precio) subtotal_ = redondear2(precioUnitarioNeto(precio, false) * aMonto(cantidad))

    if (cantidad && precio && descuento && tipoDescuento) {
      const montos = montosDeLinea({
        precio,
        cantidad,
        tipoDescuento: tipoDescuento === 'porcentaje' ? 'Porcentaje' : 'Monto',
        descuento,
      })
      descuento_ = montos.descuento
      total_ = montos.venta
      totalConImpuesto1 = redondear2(subtotal_ + totalImpuesto1)
      totalConImpuesto1Desc = redondear2(totalConImpuesto1 - descuento_)
    }

    const body = {
      cantidadDescuento: String(descuento_),
      subtotal: String(subtotal_),
      total: String(total_),
      impuesto1: String(impuesto1),
      totalImpuesto1: String(totalImpuesto1),
      totalConImpuesto1: String(totalConImpuesto1),
      totalConImpuesto1Desc: String(totalConImpuesto1Desc),
    }
    if (edit) dispatch(sujetoExcluidoFormProductoHandleChangeEdit(body))
    else dispatch(sujetoExcluidoFormProductoHandleChange(body))
  }

export const sujetoExcluidoFormProductoAddProducto =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    const edit = getState().sujetoExcluido.modals.activeEditar
    let formProductos = edit ? getState().sujetoExcluido.formProductosEdit : getState().sujetoExcluido.formProductos
    let errorsFormProductos = edit ? getState().sujetoExcluido.errorsFormProductosEdit : getState().sujetoExcluido.errorsFormProductos

    // Validaciones
    errorsFormProductos.descripcion = validators.validacionEsRequerido(formProductos.descripcion!, errorsFormProductos.descripcion!, 'Descripción', 'requerida')

    errorsFormProductos.cantidad = validators.validacionEsRequerido(formProductos.cantidad!, errorsFormProductos.cantidad!)
    if (!errorsFormProductos.cantidad) errorsFormProductos.cantidad = validators.validacionNumMinimo(formProductos.cantidad!, 0)
    if (!errorsFormProductos.cantidad) errorsFormProductos.cantidad = validators.validacionNumMaximo(formProductos.cantidad!, 100000000000)

    errorsFormProductos.precio = validators.validacionEsRequerido(formProductos.precio!, errorsFormProductos.precio!)
    if (!errorsFormProductos.precio) errorsFormProductos.precio = validators.validacionNumMinimo(formProductos.precio!, 0)
    if (!errorsFormProductos.precio) errorsFormProductos.precio = validators.validacionNumMaximo(formProductos.precio!, 100000000000)

    errorsFormProductos.tipoDescuento = validators.validacionEsRequerido(formProductos.tipoDescuento!, errorsFormProductos.tipoDescuento!)

    errorsFormProductos.descuento = validators.validacionEsRequerido(formProductos.descuento!, errorsFormProductos.descuento!)
    if (!errorsFormProductos.descuento) errorsFormProductos.descuento = validators.validacionNumMaximo(formProductos.descuento!, 100000000000)

    // Validación de Descuento
    if (!errorsFormProductos.descuento) {
      const {tipoDescuento, precio, cantidad} = formProductos
      const {messageError, ms} = validacionDescuento(formProductos.descuento!, tipoDescuento!, precio!, cantidad!)
      if (messageError) {
        dispatch(generalOpenModalError(messageError))
        errorsFormProductos.descuento = ms
      }
    }
    // Fin de Validaciones

    if (edit) dispatch(sujetoExcluidoFormProductoAddErrorEdit(errorsFormProductos))
    else dispatch(sujetoExcluidoFormProductoAddError(errorsFormProductos))    

    if (errorsFormProductos.descripcion || errorsFormProductos.cantidad || errorsFormProductos.precio || errorsFormProductos.tipoDescuento || errorsFormProductos.descuento) return

    if (edit) {
      dispatch(sujetoExcluidoArrayProductoEditar())
      dispatch(generalOpenModalInfo('El producto fue editado satisfactoriamente.'))
    } else {
      await dispatch(sujetoExcluidoArrayProductoAgregar({...getState().sujetoExcluido.formProductos}))
      await dispatch(sujetoExcluidoFormProductoClear())
      dispatch(generalOpenModalInfo('Producto agregado correctamente.'))
    }
  }

export const sujetoExcluidoCalculoTotalArrayProducto =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    const arrayProductos = getState().sujetoExcluido.arrayProductos
    const {checkReteRenta} = getState().sujetoExcluido.formCliente
    let subtotal = 0, descuento = 0, total = 0, cantidad = 0, impuesto1 = 0,
      impuesto2 = 0, totalConImpuesto1 = 0, subTotalConImpuesto1 = 0, totalIvaPercibido=0, totalConRetecion = 0,
      totalRetencionRenta = 0, totalMontoOperacion = 0, totalPagar = 0

    if (arrayProductos.length > 0) {
      subtotal = redondear2(arrayProductos.reduce((acumulado, p) => acumulado + aMonto(p.subtotal), 0))
      descuento = redondear2(arrayProductos.reduce((acumulado, p) => acumulado + aMonto(p.cantidadDescuento), 0))
      total = redondear2(arrayProductos.reduce((acumulado, p) => acumulado + aMonto(p.total), 0))
      cantidad = arrayProductos.reduce((acumulado, p) => acumulado + aMonto(p.cantidad), 0)
      impuesto1 = redondear2(arrayProductos.reduce((acumulado, p) => acumulado + aMonto(p.totalImpuesto1), 0))
      if(checkReteRenta !== true) {
        const baseDeServicios = redondear2(
          arrayProductos.reduce((acumulado, p) => acumulado + (p.tipo === 's' ? aMonto(p.total) : 0), 0)
        )
        totalRetencionRenta = retencionRenta(baseDeServicios)
      }
      // totalMontoOperacion = total
      totalMontoOperacion = total
      // totalPagar = Monto de Operación - Retencion Renta
      totalPagar = redondear2(totalMontoOperacion + totalIvaPercibido - totalRetencionRenta - impuesto2)
    }
    dispatch(
      sujetoExcluidoArrayProductoSetCalculos({
        subtotal: String(subtotal),
        descuento: String(descuento),
        total: String(total),
        totalCantidad: String(cantidad),
        totalImpuesto1: String(impuesto1),
        totalImpuesto2: String(impuesto2),
        subTotalConImpuesto1: String(subTotalConImpuesto1),
        totalConImpuesto1: String(totalConImpuesto1),
        totalConRetecion: String(totalConRetecion),
        totalIvaPercibido: String(totalIvaPercibido),
        totalRetencionRenta: String(totalRetencionRenta),
        totalMontoOperacion: String(totalMontoOperacion),
        totalPagar: String(totalPagar),
      })
    )
  }
  
export const sujetoExcluidoProductosVerificacionServicios = () => async(dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
  const productos = getState().sujetoExcluido.arrayProductos;
  const servicios = productos.filter((el) => el.tipo === "s");
  return servicios.length > 0;
}

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const sujetoExcluidoFormProductoValidacionesOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<any>, getState: () => State) => {
    const edit = getState().sujetoExcluido.modals.activeEditar
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'descripcion':
        message = validators.validacionEsRequerido(value, message, 'Descripción', 'requerida')
        break
      case 'cantidad':
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMinimo(value, 0)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)
        break
      case 'precio':
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMinimo(value, 0)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)
        break
      case 'tipoDescuento':
        message = validators.validacionEsRequerido(value, message)
        break
      case 'descuento':
        message = validators.validacionEsRequerido(value, message)
        if (!message) message = validators.validacionNumMaximo(value, 100000000000)

        // Validación de Descuento
        if (!message) {
          const {tipoDescuento, precio, cantidad} = edit
            ? getState().sujetoExcluido.formProductosEdit
            : getState().sujetoExcluido.formProductos
          const {messageError, ms} = validacionDescuento(value, tipoDescuento!, precio!, cantidad!)
          if (messageError && !edit) dispatch(generalOpenModalError(messageError))
          message = ms
        }

        break
      default:
        break
    }

    if (edit) dispatch(sujetoExcluidoFormProductoAddErrorEdit({[name]: message}))
    else dispatch(sujetoExcluidoFormProductoAddError({[name]: message}))
  }

const validacionDescuento = (
  value: string,
  tipoDescuento: string,
  precio: string,
  cantidad: string
) => {
  let messageError = '',
    ms = ''
  let num = parseFloat(value)
  if (tipoDescuento === 'porcentaje') {
    if (num > 100) {
      messageError = 'El Descuento no puede ser mayor a 100%'
      ms = 'Desc. incorrecto'
    }
  } else {
    if (precio && cantidad) {
      let subtotal = Number(precio) * Number(cantidad)
      if (num > subtotal) {
        messageError = 'El Descuento no debe ser mayor al subtotal'
        ms = 'Desc. incorrecto'
      }
    }
  }
  return {messageError, ms}
}
